<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="name">
        <el-input v-model="queryParams.name"  placeholder="国家名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="countryCode">
        <el-input v-model="queryParams.countryCode"  placeholder="国家编码" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="englishName">
        <el-input v-model="queryParams.englishName"  placeholder="国家英文名称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item prop="country">
        <el-input v-model="queryParams.country"  placeholder="国际简称" clearable style="width: 210px" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item  prop="channels">
        <el-select v-model="queryParams.channels" filterable placeholder="国际资源" @change="search" clearable multiple >
          <el-option value="cmlink" label="ZY国际"></el-option>
          <el-option value="multi" label="RY国际"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="continent">
        <el-select v-model="queryParams.continent" filterable placeholder="大洲名称" @change="search" clearable >
          <el-option value="亚洲" label="亚洲"></el-option>
          <el-option value="非洲" label="非洲"></el-option>
          <el-option value="北美洲" label="美洲"></el-option>
          <el-option value="欧洲" label="欧洲"></el-option>
          <el-option value="大洋洲" label="大洋洲"></el-option>
          <el-option value="港澳台" label="港澳台"></el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
      <el-button type="primary" icon="el-icon-plus"  @click="add">新增</el-button>
      <el-button type="primary" icon="el-icon-setting"  @click="handleChannelCountry">资源配置</el-button>
      <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
    </el-form>
    <el-table v-loading="loading" :data="tableData" border>
      <el-table-column type="index" label="序号" align="center"></el-table-column>
      <el-table-column prop="name" label="国家名称" align="center"  :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="countryCode" label="国家编码" align="center"  :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="englishName" label="国家英文名称" align="center" :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="continent" label="大洲名称" align="center" min-width="60"></el-table-column>
      <el-table-column prop="country" label="国际简称" align="center"  :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="mcc" label="MCC" align="center"  :show-overflow-tooltip="true"  ></el-table-column>
      <el-table-column prop="currency" label="支付币种" align="center"  :show-overflow-tooltip="true"  >
        <span  slot="header">
          支付币种
          <el-tooltip content="以1元人民币为基础单位换算" placement="top">
              <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <template slot-scope="{row}">
          <span>{{row.currency}}</span>
          <span style="color:red">（{{row.currencyRate}}）</span>
        </template>
      </el-table-column>
      <el-table-column prop="currencySymbol" label="币种符号" align="center"  :show-overflow-tooltip="true"  >
        <template slot-scope="{row}">
          <el-tag type="success">{{row.currencySymbol}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="channelNames" label="资源渠道" align="center" min-width="120" :show-overflow-tooltip="true"  >
        <template slot-scope="{row}">
          <el-tag style="margin-left:10px" type="success" v-for="item in row.channelNames" :key="item">{{item}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="100"></el-table-column>
      <el-table-column label="操作" align="center" min-width="80" fixed="right" v-if="checkPermi(['country:edit'])">
        <template slot-scope="{row}">
          <el-button size="mini" type="primary" plain @click="handleEdit(row)" icon="el-icon-edit">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <el-dialog title="编辑国家" :visible.sync="open" :lock-scroll="false" width="700px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="countryForm" ref="form" :rules="rules"  label-width="140px">
        <el-form-item label="国家名称:" prop="name" >
          <span>{{countryForm.name}}</span>
        </el-form-item>
        <el-form-item label="大洲名称:" prop="continent" >
          <el-select v-model="countryForm.continent" filterable placeholder="大洲名称" style="width:100%">
            <el-option value="亚洲" label="亚洲"></el-option>
            <el-option value="非洲" label="非洲"></el-option>
            <el-option value="北美洲" label="北美洲"></el-option>
            <el-option value="南美洲" label="南美洲"></el-option>
            <el-option value="南极洲" label="南极洲"></el-option>
            <el-option value="欧洲" label="欧洲"></el-option>
            <el-option value="大洋洲" label="大洋洲"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="MCC:" prop="mcc" >
          <el-input v-model="countryForm.mcc" placeholder="MCC"></el-input>
        </el-form-item>
        <el-form-item label="国家编码:" prop="countryCode" >
          <el-input disabled v-model="countryForm.countryCode" placeholder="MCC"></el-input>
        </el-form-item>
        <el-form-item label="支付币种:" prop="currency" >
          <el-select v-model="countryForm.currency" filterable  placeholder="请选择支付币种" style="width:100%">
            <el-option
              v-for="item in currencyData"
              :key="item.currency"
              :label="item.name+'-'+item.currency+'-('+item.exchangeRateCny +')'"

              :value="item.currency"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源渠道:" prop="channels" >
          <el-select v-model="countryForm.channels" filterable multiple  placeholder="请选择资源渠道" style="width:100%">
            <el-option label="ZY国际" value="cmlink"></el-option>
            <el-option label="RY国际" value="multi"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancel">取消</el-button>
        <el-button type="success" @click="submit">确认</el-button>
      </div>
    </el-dialog>
    <!-- 新增国家 -->
    <el-dialog title="新增国家" :visible.sync="addOpen" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="addForm" ref="addForm" :rules="addRules"  label-width="140px">
        <el-form-item label="国家名称:" prop="name" >
          <el-input v-model="addForm.name" placeholder="国家名称"></el-input>
        </el-form-item>
        <el-form-item label="大洲名称:" prop="continent" >
          <el-select v-model="addForm.continent" filterable placeholder="大洲名称" style="width:100%">
            <el-option value="亚洲" label="亚洲"></el-option>
            <el-option value="非洲" label="非洲"></el-option>
            <el-option value="北美洲" label="北美洲"></el-option>
            <el-option value="南美洲" label="南美洲"></el-option>
            <el-option value="南极洲" label="南极洲"></el-option>
            <el-option value="欧洲" label="欧洲"></el-option>
            <el-option value="大洋洲" label="大洋洲"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="国家英文名称:" prop="englishName" >
          <el-input v-model="addForm.englishName" placeholder="国家英文名称"></el-input>
        </el-form-item>
        <el-form-item label="国家编码:" prop="countryCode" >
          <el-input v-model="addForm.countryCode" placeholder="国家编码"></el-input>
        </el-form-item>
        <el-form-item label="国际简称:" prop="country" >
          <el-input v-model="addForm.country" placeholder="国际简称"></el-input>
        </el-form-item>
        <el-form-item label="MCC:" prop="mcc" >
          <el-input v-model="addForm.mcc" placeholder="MCC"></el-input>
        </el-form-item>
        <el-form-item label="支付币种:" prop="currency" >
          <el-select v-model="addForm.currency" filterable  placeholder="请选择支付币种" style="width:100%">
            <el-option
              v-for="item in currencyData"
              :key="item.currency"
              :label="item.name+'-'+item.currency+'-'+item.currencySymbol"
              :value="item.currency"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资源渠道:" prop="channels" >
          <el-select v-model="addForm.channels" filterable multiple  placeholder="请选择资源渠道" style="width:100%">
            <el-option label="ZY国际" value="cmlink"></el-option>
            <el-option label="RY国际" value="multi"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelAdd">取消</el-button>
        <el-button type="success" @click="submitAdd">确认</el-button>
      </div>
    </el-dialog>
    <!-- 资源配置国家 -->
    <el-dialog title="资源配置" :visible.sync="dialogCountry" :lock-scroll="false" width="650px" v-dialogDrag :close-on-click-modal="false">
      <el-form :model="channelForm" ref="channelForm" :rules="channelRules"  label-width="140px">
        <el-form-item label="国际资源" prop="channel">
          <el-select v-model="channelForm.channel"  filterable placeholder="国际资源" clearable  @change="selectChannelCountry">
            <el-option value="cmlink" label="ZY国际"></el-option>
            <el-option value="multi" label="RY国际"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支持国家" prop="country">
          <el-checkbox v-model="countryNodeAll" @change="handleCheckedTreeNodeAll($event)" >全选/全不选</el-checkbox>
          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText" 
            style="width: 80%">
          </el-input>
          <el-tree
            style="width: 80%"
            class="tree-border"
            :data="countryOptions"
            show-checkbox
            ref="menu"
            node-key="countryCode"
            :filter-node-method="filterNode"
            empty-text="加载中，请稍候"
            :props="defaultProps"
          >
          <template #default="{ data }">
            <span>{{ data.name }} ({{ data.englishName }})</span>
          </template>
          </el-tree>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" @click="cancelChannel">取消</el-button>
        <el-button type="success" @click="submitChannelCountry">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { countryPage  , countryList , updateCountry , internationalChannelCountryList ,saveInternationalChannelCountry , addCountry} from "@/api/international.js";
import { currencyList } from "@/api/config.js";
export default {
  name: "countryList",
  data() {
    return {
      // 查询条件
      queryParams: {
        name:undefined,
        englishName:undefined,
        countryCode:undefined,
        country:undefined,
        channels:[],
        continent:undefined
      },
      // 遮罩层
      loading: true,
      // 分页器
      page: 1,
      pageSize: 10,
      total: 10,
      // 列表数据
      tableData: [],
      currencyData:[],
      addOpen:false,
      addForm:{},
      addRules:{
        name: [
          { required: true, message: "国家名称不能为空", trigger: "blur" },
        ],
        continent: [
          { required: true, message: "大洲名称不能为空", trigger: "blur" },
        ],
        englishName: [
          { required: true, message: "国家英文名称不能为空", trigger: "blur" },
        ],
        countryCode: [
          { required: true, message: "国家编码不能为空", trigger: "blur" },
        ],
        country: [
          { required: true, message: "国际简称不能为空", trigger: "blur" },
        ],
        currency: [
          { required: true, message: "支付币种不能为空", trigger: "blur" },
        ],
        mcc: [
          { required: true, message: "MCC不能为空", trigger: "blur" },
        ],
        
      },
      open:false,
      countryForm:{
        id:undefined,
        currency:undefined,
        currencySymbol:undefined,
        continent:undefined,
        mcc:undefined,
        channels:[]
      },
      rules: {
        continent: [
          { required: true, message: "大洲名称不能为空", trigger: "blur" },
        ],
        currency: [
          { required: true, message: "支付币种不能为空", trigger: "blur" },
        ],
        mcc: [
          { required: true, message: "MCC不能为空", trigger: "blur" },
        ],
      },
      dialogCountry:false,
      countryNodeAll:false,
      //国家列表
      countryOptions:[],
      filterText:'',
      defaultProps: {
        label: "name"
      },
      channelForm:{},
      channelRules: {
        channel: [
          { required: true, message: "国际资源不能为空", trigger: "blur" },
        ],
      },
    };
  },
  watch:{
    filterText(param){
      this.$refs.menu.filter(param);
    } 
  },
  methods: {
    // 搜索
    handleSearch() {
      this.initData();
    },
    // 获取列表
    initData() {
      this.loading=true;
      let params = {
        model:{
          ...this.queryParams
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      countryPage(params).then(res => {
        this.loading=false;
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      });
    },
    add(){
      this.addOpen = true
    },
    cancelAdd(){
      this.addOpen = false
      this.addForm = {}
    },
    submitAdd(){
      this.$refs.addForm.validate(valid => {
          if (valid) {
            addCountry(this.addForm).then(res=>{
              this.cancelAdd()
              this.initData()
            })
          }
      })
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    //货币
    selectCurrencyList(){
      currencyList().then(res=>{
        this.currencyData  = res.data.data
      })
    },
    //国家
    selectCountryList(){
      countryList().then(res=>{
        this.countryOptions = res.data.data
      })
    },
    handleChannelCountry(){
      this.dialogCountry = true
    },
    // 树权限（全选/全不选）
    handleCheckedTreeNodeAll(value) {
      this.$refs.menu.setCheckedNodes(value ? this.countryOptions: []);
    },
    // 所有菜单节点数据
    getMenuAllCheckedKeys() {
      // 目前被选中的菜单节点
      let checkedKeys = this.$refs.menu.getCheckedKeys();
      return checkedKeys;
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    handleEdit(data){
      Object.assign(this.countryForm, data)
      this.countryForm.currencySymbol = data.currency
      this.countryForm.countryId = data.countryId || data.id
      this.open = true
    },
    submit(){
      updateCountry(this.countryForm).then(res=>{
        this.open = false
        this.countryForm = {
          id:undefined,
          currency:undefined,
          currencySymbol:undefined,
          continent:undefined,
          mcc:undefined,
          channels:[]
        }
        this.search()
      })
    },
    cancel(){
      this.open = false
      this.countryForm = {
        id:undefined,
        currency:undefined,
        currencySymbol:undefined,
        continent:undefined,
        mcc:undefined,
        channels:[]
      }
    },
    cancelChannel(){
      this.dialogCountry = false
      this.channelForm = {}
    },
    selectChannelCountry(selected){
      internationalChannelCountryList({'channel':selected}).then(res=>{
        let checkedKeys = res.data.data
        checkedKeys.forEach((v) => {
            this.$nextTick(()=>{
                this.$refs.menu.setChecked(v, true ,false);
            })
        })
      })
    },
    submitChannelCountry(){
      this.$refs.channelForm.validate(valid => {
          if (valid) {
              this.channelForm.countryCodes = this.getMenuAllCheckedKeys();
              saveInternationalChannelCountry(this.channelForm).then(res=>{
                  this.cancelChannel()
                  this.initData()
              })
          }
      })
    }
  },
  created() {
    this.initData()
    this.selectCurrencyList()
    this.selectCountryList()
  },
};
</script>
<style scoped lang="less">
.el-button {
  margin-left: 5px;
  border-radius: 3px;
  padding: 10px 20px;
}
/deep/.tree-border {
  max-height: 50vh; /* 最大高度为视口高度的70%，可根据需求调整 */
  overflow-y: auto; /* 超出时显示垂直滚动条 */
  padding-top: 15px; /* 可选：调整内边距，优化布局 */
}

/deep/.tree-border::-webkit-scrollbar {
  width: 6px;
}
/deep/.tree-border::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}

</style>
